export enum UserRole {
  GUEST = "documents:guest",
  TESTER = "documents:tester",
  COMMON = "documents:common",
  SUPPLIER = "documents:supplier",
  ADMIN = "documents:admin",
  CONTRACT_VIEWER = "documents:contract_viewer",
  PAYOUT_APPROVER = "documents:payout_approver",
  DEVELOPER = "documents:developer",
  WORK_APPROVER = "documents:work_approver",
}
